import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-settings',
  templateUrl: './AdminSettingsComponent.html',
  styleUrls: [ './AdminSettingsComponent.scss' ]
})
export class AdminSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
